import React from "react";
import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getApi, postApi } from "../../services/apiServices";
import Modal from "react-modal";
import { toast } from "react-toastify";
function ViewUserManagement() {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false);
  const [isUnblockModalOpen, setIsUnblockModalOpen] = useState(false);
  const [isBlocking, setIsBlocking] = useState(false);
  const [isUnblocking, setIsUnblocking] = useState(false);
  const [activeTab, setActiveTab] = useState('resume');


  const displayData = (data) => {
    if (data === null || data === undefined || data === "" || data === "N/A") {
      return "-";
    }
    return data;
  };

  const fetchUserDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getApi(`/user/profile?user_id=${id}`);

      if (response?.statusCode === 200) {
        setUserData(response.data);
      } else {
        setError(response?.message || "Failed to fetch user details");
        console.error("Failed to fetch user details:", response?.message);
      }
    } catch (error) {
      setError("Error fetching user details. Please try again.");
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    if (id) {
      fetchUserDetails();
    }
  }, [id]);

  const openBlockModal = (e) => {
    e.preventDefault();
    setIsBlockModalOpen(true);
  };

 
  const closeBlockModal = () => {
    setIsBlockModalOpen(false);
  };

  const openUnblockModal = (e) => {
    e.preventDefault();
    setIsUnblockModalOpen(true);
  };

  const closeUnblockModal = () => {
    setIsUnblockModalOpen(false);
  };

  const handleBlock = async () => {
    if (!userData) return;

    setIsBlocking(true);
    try {
      const response = await postApi("/block-user", {
        user_id: userData.id,
        status: "2",
      });

      if (response?.statusCode === 200) {

        setIsBlockModalOpen(false);
        await fetchUserDetails();
        toast.success('User blocked successfully!');
      } else {
        console.error("Failed to block user:", response?.message);

      }
    } catch (error) {
      console.error("Error blocking user:", error);

    } finally {
      setIsBlocking(false);
    }
  };

  const handleUnblock = async () => {
    if (!userData) return;

    setIsUnblocking(true);
    try {
      const response = await postApi("/block-user", {
        user_id: userData.id,
        status: "1",
      });

      if (response?.statusCode === 200) {

        setIsUnblockModalOpen(false);
        await fetchUserDetails();
        toast.success('User unblocked successfully!');
      } else {
        console.error("Failed to unblock user:", response?.message);

      }
    } catch (error) {
      console.error("Error unblocking user:", error);
    } finally {
      setIsUnblocking(false);
    }
  };



const getAge = (timestamp) => {
  if (!timestamp) return "-";
  const dob = new Date(Number(timestamp));
  const today = new Date();

  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  const dayDiff = today.getDate() - dob.getDate();

  // Adjust if birthday hasn't happened yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};
  const handleDownloadResume = async (e) => {
    e.preventDefault();

    if (!userData?.resume) {
      toast.error('No resume available for download');
      return;
    }

    try {
      const response = await fetch(userData.resume);
      if (!response.ok) {
        throw new Error('Failed to fetch resume');
      }

      const blob = await response.blob();

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `resume_${userData.full_name || userData.id}.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(link.href);

      toast.success('Resume downloaded');
    } catch (error) {
      console.error('Error downloading resume:', error);
      toast.error('Error downloading resume. Please try again.');
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "560px",
      borderRadius: "8px",
      padding: "20px",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
  };

  return (
    <>
      <div className="right-section">
        <div className="view-heading">
          <ul>
            <li>
              <Link to="/admin/userManagement" className="active">
                <img
                  src={window.getPublicUrl("/images/back-button.svg")}
                  alt="Back"
                />{" "}
                Back to User
              </Link>
            </li>
          </ul>
        </div>

        {loading && (
          <div className="loader-overlay">
            <span className="loader"></span>
          </div>
        )}

        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {!loading && !error && userData && (
          <>

            <div className="profile-data">
              <div className="row">
                <div className="col-md-2">
                  <ul className="user-data">
                    <li>
                      <span>
                        <img
                          src={
                            userData.User_Images &&
                              userData.User_Images.length > 0 &&
                              userData.User_Images[0].image
                              ? userData.User_Images[0].image
                              : window.getPublicUrl("/images/john.svg")
                          }
                          alt="User"
                        />
                      </span>
                    </li>
                    <li>
                      <h3 className="profile-haeding">
                        {displayData(userData.full_name)}
                      </h3>
                      {/* <p className="location">
                  <img src={window.getPublicUrl('/images/location.svg')} className="img-fluid pr-2" alt="Location" /> {userData.location || "N/A"}
                </p> */}
                    </li>
                  </ul>
                </div>

                <div className="col-md-3">
                  <div className="inner-profile-data">
                    <ul className="user-list-data">
                      <li>
                        <p>Email</p>
                        <span>
                          <img
                            src={window.getPublicUrl("/images/line.svg")}
                            alt=""
                          />
                        </span>
                        <h4>{displayData(userData.email)}</h4>
                      </li>
                      <li>
                        <p>Phone</p>
                        <span>
                          <img
                            src={window.getPublicUrl("/images/line.svg")}
                            alt=""
                          />
                        </span>
                        <h4>{displayData(userData.phone_number)}</h4>
                      </li>
                      <li>
                        <p>Verified</p>
                        <span>
                          <img
                            src={window.getPublicUrl("/images/line.svg")}
                            alt=""
                          />
                        </span>
                        <h4>
                          {userData.email_verify || userData.phone_verify
                            ? "Yes"
                            : "No"}
                        </h4>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-3">
                  <ul className="user-list-data dates-details">
                    <li>
                      <p>Gender</p>
                      <span>
                        <img
                          src={window.getPublicUrl("/images/line.svg")}
                          alt=""
                        />
                      </span>
                      <h4>
                        {userData.gender === 1
                          ? "Man"
                          : userData.gender === 2
                            ? "Woman"
                            : userData.gender === 3
                              ? "Nonbinary"
                              : "-"}
                      </h4>
                    </li>
                    <li>
                      <p>Plan</p>
                      <span>
                        <img
                          src={window.getPublicUrl("/images/line.svg")}
                          alt=""
                        />
                      </span>
                                          <h4>
                        {userData.package_type === 1
                          ? "Free"
                          : userData.package_type === 2
                            ? "Premium"
                            : userData.gender === 3
                              ? "Premium plus"
                              : "-"}
                      </h4>
                    </li>
                    <li>
                      <p>Joined On</p>
                      <span>
                        <img
                          src={window.getPublicUrl("/images/line.svg")}
                          alt=""
                        />
                      </span>
                      <h4>
                        {userData.createdAt
                          ? new Date(userData.createdAt).toLocaleDateString(
                            "en-GB",
                            {
                              day: "numeric",
                              month: "long",
                              year: "numeric",
                            }
                          )
                          : "-"}
                      </h4>
                    </li>
                  </ul>
                </div>

                <div className="col-md-4">
                  <div className="button-seetings">
                    <button
                      className={`btn send-email ${userData.status === "2" ? "verify-block" : ""
                        }`}
                    >
                      {userData.status === "2" ? "Blocked" : "Active"}
                    </button>

                    {/* Send Email Modal */}
                    <div
                      className="modal fade"
                      id="sendemail"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="sendemailTitle"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered send-email-modal"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title"
                              id="exampleModalLongTitle"
                            >
                              Send Email
                            </h5>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <img
                                src={window.getPublicUrl(
                                  "/images/close-icon.svg"
                                )}
                                alt="Close"
                              />
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="admin@travelsim.com"
                                    name="email"
                                  />
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Subject</label>
                                  <div className="select-option w-100">
                                    <select
                                      name="cars"
                                      id="cars"
                                      className="w-100"
                                    >
                                      <optgroup label="Swedish Cars">
                                        <option value="Special Offer">
                                          Special Offer
                                        </option>
                                      </optgroup>
                                      <optgroup label="German Cars">
                                        <option value="Special Offer">
                                          Special Offer
                                        </option>
                                      </optgroup>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label>Description</label>
                                  <textarea
                                    id="story"
                                    className="w-100"
                                    name="story"
                                    rows="5"
                                    cols="33"
                                    defaultValue="Hello Aditi Verma, Enjoy 20% off on your next top-up."
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-cancel"
                              data-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button type="button" className="btn btn-save">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {userData.status !== "2" && (
                      <button className="block-btn" onClick={openBlockModal}>
                        Block User
                      </button>
                    )}

                    {userData.status === "2" && (
                      <button className="block-btn" onClick={openUnblockModal}>
                        Unblock User
                      </button>
                    )}

                    {/* Block User Modal */}
                    <Modal
                      isOpen={isBlockModalOpen}
                      onRequestClose={closeBlockModal}
                      style={customStyles}
                      contentLabel="Block User Confirmation"
                    >
                      <div className="">
                        <div className="modal-content">
                          <div className="modal-header">
                            <div className="block-img">
                              <img
                                src={window.getPublicUrl("/images/block.svg")}
                                className="img-fluid"
                                alt="Block icon"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={closeBlockModal}
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <img
                                src={window.getPublicUrl("/images/close-icon.svg")}
                                alt="Close"
                              />
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <h3>Block User</h3>
                                <p>
                                  Are you sure you want to Block this Account?
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-cancel"
                              data-dismiss="modal"
                              onClick={closeBlockModal}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-save"
                              onClick={handleBlock}
                              disabled={isBlocking}
                            >
                              {isBlocking ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Blocking...
                                </>
                              ) : (
                                "Block User"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Modal>

                    {/* Unblock User Modal */}
                    <Modal
                      isOpen={isUnblockModalOpen}
                      onRequestClose={closeUnblockModal}
                      style={customStyles}
                      contentLabel="Unblock User Confirmation"
                    >
                      <div className="">
                        <div className="modal-content">
                          <div className="modal-header">
                            <div className="unblock-img">
                              <img
                                src={window.getPublicUrl("/images/unblock.svg")}
                                className="img-fluid"
                                alt="Unblock icon"
                              />
                            </div>
                            <button
                              type="button"
                              onClick={closeUnblockModal}
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <img
                                src={window.getPublicUrl(
                                  "/images/close-icon.svg"
                                )}
                                alt="Close"
                              />
                            </button>
                          </div>
                          <div className="modal-body">
                            <div className="row">
                              <div className="col-sm-12">
                                <h3>Unblock User</h3>
                                <p>
                                  Are you sure you want to Unblock this Account?
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-cancel"
                              data-dismiss="modal"
                              onClick={closeUnblockModal}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-save"
                              onClick={handleUnblock}
                              disabled={isUnblocking}
                            >
                              {isUnblocking ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Unblocking...
                                </>
                              ) : (
                                "Unblock User"
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>

            {/* Media Section */}

            {/* -----------------------------------user media and infor tab start data ----------------- */}

            <div className="customer-top-right"></div>

            <div className="media-details">
              <div className="row">
                <div className="col-md-6">
                  <div className="customer-top-left resume-info-show">
                    <ul>
                      <li>
                        <a
                          href="#"
                          className={`media ${activeTab === 'resume' ? 'active' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleTabChange('resume');
                          }}
                        >
                          Resume Questions{" "}
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          className={activeTab === 'userInfo' ? 'active' : ''}
                          onClick={(e) => {
                            e.preventDefault();
                            handleTabChange('userInfo');
                          }}
                        >
                          User Info
                        </a>
                      </li>
                    </ul>
                    <h3 className="media-head mb-0"><a href="" onClick={handleDownloadResume}>Download Resume</a></h3>
                  </div>
                  <div className="media-images">
                    {activeTab === 'resume' ? (

                      userData.Answers && userData.Answers.length > 0 ? (
                        userData.Answers.map((answer, index) => (
                          <div className="question-ans" key={index}>
                            <h6>
                              <span>Q{index + 1}.</span>
                              {answer.question}
                            </h6>
                            <p>
                              <span>Ans:</span> {answer.answer}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>No answers available</p>
                      )
                    ) : (

                      <div className="user-info">
                        <ul className="user-list-data">
       <li>
  <p>Age</p>
  <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
  <h4>{getAge(userData.dob)}</h4>
</li>
                          <li>
                            <p>Gender</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.gender === 1 ? 'Man' : userData.gender === 2 ? 'Woman' : userData.gender === 3 ? 'Nonbinary' : '-'}</h4>
                          </li>
                          <li>
                            <p>Marital Status</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.marital_status === 1 ? 'Single' : userData.marital_status === 2 ? 'Married' : userData.marital_status === 3 ? 'Divorced' : userData.marital_status === 4 ? 'Widowed' : userData.marital_status === 5 ? 'Separated' : '-'}</h4>
                          </li>
                          <li>
                            <p>Profession</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{displayData(userData.profession)}</h4>
                          </li>
                          <li>
                            <p>Ethnicity</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.ethnicity === 1 || userData.ethnicity === "1" ? 'White' : userData.ethnicity === 2 || userData.ethnicity === "2" ? 'East/SouthEast Asian' : userData.ethnicity === 3 || userData.ethnicity === "3" ? 'South Asian' : userData.ethnicity === 4 || userData.ethnicity === "4" ? 'Black' : userData.ethnicity === 5 || userData.ethnicity === "5" ? 'Hispanic' : userData.ethnicity === 6 || userData.ethnicity === "6" ? 'Middle Eastern' : userData.ethnicity === 7 || userData.ethnicity === "7" ? 'Middle Eastern' : displayData(userData.ethnicity)}</h4>
                          </li>
                          <li>
                            <p>Height</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{displayData(userData.height)}</h4>
                          </li>
                          <li>
                            <p>Religion</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.religion === 1 || userData.religion === "1" ? 'Agnostic' : userData.religion === 2 || userData.religion === "2" ? 'Atheist' : userData.religion === 3 || userData.religion === "3" ? 'Buddhist' : userData.religion === 4 || userData.religion === "4" ? 'Christian' : userData.religion === 5 || userData.religion === "5" ? 'Hindu' : userData.religion === 6 || userData.religion === "6" ? 'Jewish' : userData.religion === 7 || userData.religion === "7" ? 'Muslim' : userData.religion === 8 || userData.religion === "8" ? 'Mormon' : userData.religion === 9 || userData.religion === "9" ? 'Other' : displayData(userData.religion)}</h4>
                          </li>
                          <li>
                            <p>Education</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.education === 1 || userData.education === "1" ? "High School" : userData.education === 2 || userData.education === "2" ? "College/Associate" : userData.education === 3 || userData.education === "3" ? "Bachelor" : userData.education === 4 || userData.education === "4" ? "Master" : userData.education === 5 || userData.education === "5" ? "Doctorate" : userData.education === 6 || userData.education === "6" ? "Trade/Technical School" : userData.education === 7 || userData.education === "7" ? "Other" : displayData(userData.education)}</h4>
                          </li>
                          <li>
                            <p>Preferred Meeting Gender</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.preferred_meeting_gender === 1 ? 'Men' : userData.preferred_meeting_gender === 2 ? 'Women' : userData.preferred_meeting_gender === 3 ? 'Nonbinary' : userData.preferred_meeting_gender === 4 ? 'Everyone' : '-'}</h4>
                          </li>
                          <li>
                            <p>Have Kids</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.have_kid === 1 ? 'Yes' : userData.have_kid === 0 || userData.have_kid === 2 ? 'No' : '-'}</h4>
                          </li>
                          <li>
                            <p>Kids Age Range</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.kids_age_range === 1 ? '1-5 years' : userData.kids_age_range === 2 ? '6-18 years' : userData.kids_age_range === 3 ? '18+ years' : displayData(userData.kids_age_range)}</h4>
                          </li>
                          <li>
                            <p>Smoking Habit</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.smoking_habit === 1 ? 'Yes' : userData.smoking_habit === 2 ? 'No' : userData.smoking_habit === 3 ? 'Occasionally' : '-'}</h4>
                          </li>
                          <li>
                            <p>Drinking Habit</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.drinking_habit === 1 ? 'Yes' : userData.drinking_habit === 2 ? 'No' : userData.drinking_habit === 3 ? 'Occasionally' : '-'}</h4>
                          </li>
                          <li>
                            <p>Exercise Level</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{userData.exercise_level === 1 ? 'Low' : userData.exercise_level === 2 ? 'Mid' : userData.exercise_level === 3 ? 'High' : '-'}</h4>
                          </li>
                          <li>
                            <p>Location</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{displayData(userData.location)}</h4>
                          </li>
                          <li>
                            <p>Country Code</p>
                            <span><img src={window.getPublicUrl("/images/line.svg")} alt="" /></span>
                            <h4>{displayData(userData.country_code)}</h4>
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                  {/* ---------------------user-info------------------------ */}
                </div>

                <div className="col-md-3">
                  <h3 className="media-head">Media</h3>
                  <div className="media-images">
                    {userData.User_Images && userData.User_Images.length > 0 ? (
                      <ul className="img-list">
                        {userData.User_Images.map((image, index) => (
                          <li key={index}>
                            <span>
                              <img
                                src={
                                  image.image ||
                                  window.getPublicUrl("/images/media-imgae.svg")
                                }
                                alt="Media"
                              />
                            </span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>No images available</p>
                    )}
                  </div>
                </div>

             <div className="col-md-3">
  <h3 className="media-head">Activity Overview</h3>
  <div className="media-images">
    <ul className="user-list-data">
      {[
        ["Resumes Sent", userData.resumeSentCount || 0],
        ["Resumes Received", userData.resumeReceivedCount || 0],
        ["Matches Made", userData.matchesCount || 0],
        ["Calls Scheduled", userData.callScheduledCount || 0],
        ["Chats Unlocked", userData.chatsUnlockedCount || 0], // if available in backend, else keep 0
        [
          "Photos Uploaded",
          userData.User_Images ? userData.User_Images.length : 0,
        ],
      ].map(([label, value], i) => (
        <li key={i}>
          <p>{label}</p>
          <span>
            <img
              src={window.getPublicUrl("/images/line.svg")}
              alt=""
            />
          </span>
          <h4>{value}</h4>
        </li>
      ))}
    </ul>
  </div>
</div>

              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ViewUserManagement;
